module.exports = __webpack_public_path__ + "img/normal-distribution.a49ce1c2.png";